// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuescroll from 'vuescroll';
import App from './App'
import router from './router'
import spfction from './spfction'
import ElementUI from 'element-ui'
import starpostUI from 'starpost-ui'
import VueAMap from 'vue-amap'

import GlobalParamJs from '../static/js/globalParams'
import Auth from '../static/js/auth'
import VueQuillEditor from 'vue-quill-editor'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/iconfont/iconfont.css'
import '@/assets/scss/public.scss'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import request1 from '@/util/request1' // 星邮最新版springboot项目
// import request2 from '@/util/request2' // 星邮第一版springboot项目
import '@/drag/index'
import { getToken, windowOpen1 } from '@/util/auth'


// 富文本编辑框样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as filters from './filters' // 全局filter
//自定义封装toast 组件
import Toast from "@/components/toast/toast.js";
Vue.prototype.$toast = Toast;
import elTableInfiniteScroll from 'el-table-infinite-scroll';
Vue.use(elTableInfiniteScroll);
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 初始化vue-amap
// VueAMap.initAMapApiLoader({
//   key: '67cbf25aaeeb270f65bf66afaa028cb5',
//   plugin: ['Autocomplete', 'PlaceSearch', 'Scale', 'OverView', 'ToolBar', 'MapType', 'PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation', 'Geocoder']
// });

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$request1 = request1
// Vue.prototype.$request2 = request2
Vue.prototype.$getToken = getToken
Vue.prototype.$windowOpen1 = windowOpen1  // 自定义打开窗口

Vue.prototype._logo_ = _logo_
Vue.prototype.company_name = company_name

Vue.use(VueClipboard)
Vue.use(vuescroll)
Vue.use(ElementUI)
Vue.use(starpostUI)
Vue.use(spfction)
Vue.use(VueAMap)
Vue.use(VueQuillEditor)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js